import { MFAService } from '@yubi/yb-module-auth';

export default MFAService;
